import apiService from "./ApiService"
import { createQS } from "./Utils"

export const TipoHistoricoOrdemServicoEnum = {
  MOVIMENTACAO: 1,
  FISCALIZACAO: 2,
  CORRECAO: 3
}

// Mesma lista do backend (PrioridadesOrdemServico em entities/OrdemServico.ts).
// Ao incluir uma prioridade la, incluir aqui tambem.
export const prioridadesOrdemServicoList = ['P-1', 'P-2', 'P-3', 'PREF PRES']

export const StatusOrdemServicoEnum = {
  PENDENTE: 1,
  AGUARDANDO_SELECAO_EMPRESA_EXECUTORA: 2,
  EM_FASE_EXECUCAO: 5,
  AGUARDANDO_CONFERENCIA_EXECUCAO: 6,
  AGUARDANDO_FISCALIZACAO: 7,
  EM_FISCALIZACAO: 8,
  EM_FASE_CORRECAO: 11,
  AGUARDANDO_CONFERENCIA_CORRECAO: 12,
  CONCLUIDA: 13,
  CANCELADA: 14,
}

export const statusOrdemServicoList = [
  StatusOrdemServicoEnum.PENDENTE,
  StatusOrdemServicoEnum.AGUARDANDO_SELECAO_EMPRESA_EXECUTORA,
  StatusOrdemServicoEnum.EM_FASE_EXECUCAO,
  StatusOrdemServicoEnum.AGUARDANDO_CONFERENCIA_EXECUCAO,
  StatusOrdemServicoEnum.AGUARDANDO_FISCALIZACAO,
  StatusOrdemServicoEnum.EM_FISCALIZACAO,
  StatusOrdemServicoEnum.EM_FASE_CORRECAO,
  StatusOrdemServicoEnum.AGUARDANDO_CONFERENCIA_CORRECAO,
  StatusOrdemServicoEnum.CONCLUIDA,
  StatusOrdemServicoEnum.CANCELADA,
]

export function getStatusOrdemServicoDescription(status) {
  switch (status) {
    case StatusOrdemServicoEnum.PENDENTE: return "Pendente"
    case StatusOrdemServicoEnum.AGUARDANDO_SELECAO_EMPRESA_EXECUTORA: return "Aguardando Seleção Empresa Executora"
    case StatusOrdemServicoEnum.EM_FASE_EXECUCAO: return "Em Fase de Execução"
    case StatusOrdemServicoEnum.AGUARDANDO_CONFERENCIA_EXECUCAO: return "Aguardando Conferência Execução"
    case StatusOrdemServicoEnum.AGUARDANDO_FISCALIZACAO: return "Aguardando Fiscalização"
    case StatusOrdemServicoEnum.EM_FISCALIZACAO: return "Em Fiscalização"
    case StatusOrdemServicoEnum.EM_FASE_CORRECAO: return "Em Fase de Correção"
    case StatusOrdemServicoEnum.AGUARDANDO_CONFERENCIA_CORRECAO: return "Aguardando Conferência Correção"
    case StatusOrdemServicoEnum.CONCLUIDA: return "Concluída"
    case StatusOrdemServicoEnum.CANCELADA: return "Cancelada"
  }
}

export const StatusDivergenciaEnum = {
  AGUARDANDO_CORRECAO: 'ACORR',
  AGUARDANDO_CONFERENCIA: 'ACONF',
  REPROVADA: 'R',
  APROVADA: 'A',
}

export const StatusCorrecaoEnum = {
  PENDENTE: 'P',
  REPROVADA: 'R',
  APROVADA: 'A',
}

export const StatusExecucaoEquipeEnum = {
  AGUARDANDO_EXECUCAO: 'AE',
  EM_EXECUCAO: 'EE',
  PAUSADA: 'P',
  FINALIZADA: 'F'
}

export const StatusCorrecaoEquipeEnum = {
  AGUARDANDO_CORRECAO: 'AC',
  EM_CORRECAO: 'EC',
  PAUSADA: 'P',
  FINALIZADA: 'F'
}

class OrdemServicoService {
  constructor() {
  }

  async get(termo, idLote, idFiscal, prioridade, idStatus, idContrato, pagina) {
    try {
      const qs = createQS({ termo, idLote, idFiscal, prioridade, idStatus, idContrato, pagina })
      return await apiService.get('ordem_servico?' + qs)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async getById(id) {
    try {
      return await apiService.get(`ordem_servico/${id}`)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async import(idContrato, file) {
    const formData = new FormData()
    formData.append('file', file)

    try {
      return await apiService.post(`ordem_servico/importar/${idContrato}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async create(data) {
    try {
      return await apiService.post('ordem_servico', data)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async criarManual(data) {
    try {
      return await apiService.post('ordem_servico/manual', data)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async excluir(id) {
    try {
      return await apiService.delete(`ordem_servico/${id}`)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async delete(id) {
    try {
      return await apiService.delete('ordem_servico/' + id)
    } catch (ex) {
      debugger
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async getItens(idOrdemServico) {
    try {
      return await apiService.get(`ordem_servico/${idOrdemServico}/item`)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async getItemById(idOrdemServico, idItem) {
    try {
      return await apiService.get(`ordem_servico/${idOrdemServico}/item/${idItem}`)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  getFiscalizacaoById(idOrdemServico, idFiscalizacao) {
    // const items = this.getItens(idOrdemServico)
    // const item = items.find(el => el.fiscalizacoes.some(f => f.id == idFiscalizacao))
    // const fiscalizacao = item.fiscalizacoes.find(el => el.id == idFiscalizacao)
    // return {...fiscalizacao, item}
  }

  async addItem(idOrdemServico, idContratoItem, quantidade, justificativa) {
    try {
      return await apiService.post(`ordem_servico/${idOrdemServico}/item`, {
        idContratoItem,
        quantidade,
        justificativa
      })
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async deleteItem(idOrdemServico, idContratoItem, justificativa) {
    try {
      return await apiService.delete(`ordem_servico/${idOrdemServico}/item/${idContratoItem}`, {
        justificativa
      })
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async updateItem(idOrdemServico, idContratoItem, quantidade, justificativa) {
    try {
      return await apiService.put(`ordem_servico/${idOrdemServico}/item/${idContratoItem}`, {
        quantidade,
        justificativa
      })
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async getHistorico(idOrdemServico) {
    try {
      return await apiService.get(`ordem_servico/${idOrdemServico}/movimentacao`)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  addHistorico(idOrdemServico, usuario, descricao, tipoHistorico, idItemRelacionado) {
    // const id = uuid()
    // this.historico.push({ id, idOrdemServico, data: new Date(), usuario, descricao, tipoHistorico, idItemRelacionado })
    // return id
  }

  async getHistoricoItem(idOrdemServico, idContratoItem) {
    try {
      return await apiService.get(`ordem_servico/${idOrdemServico}/item/${idContratoItem}/historico`)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  addHistoricoItem(idOrdemServico, idItem, usuario, qtdAnterior, qtdNova) {
    // const id = uuid()
    // this.historicoItem.push({ id, idOrdemServico, idItem, data: new Date(), usuario, qtdAnterior, qtdNova })
    // return id
  }

  async atribuir(idOrdemServico, idEquipe, previsaoInicio, itensSelecionados) {
    try {
      return await apiService.post(`ordem_servico/${idOrdemServico}/atribuir`, {
        idEquipe,
        previsaoInicio,
        itensSelecionados
      })
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async liberarExecucao(idOrdemServico) {
    try {
      return await apiService.post(`ordem_servico/${idOrdemServico}/liberar_execucao`)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  // SDD 038 - Liberar execucao de varias OS de uma vez. Retorna 200 mesmo com falhas:
  // data = { liberadas: [{ id, numero, ano }], falhas: [{ id, numero, ano, motivo }] }
  // O backend valida ids como numeros (string "12" -> 400), por isso o Number().
  async liberarExecucaoEmLote(ids) {
    try {
      return await apiService.post('ordem_servico/liberar_execucao', { ids: ids.map(Number) })
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  // SDD 037 - Alterar prioridade da OS (recalcula previsao de inicio e registra historico)
  async alterarPrioridade(idOrdemServico, prioridade) {
    try {
      return await apiService.put(`ordem_servico/${idOrdemServico}/prioridade`, { prioridade })
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  simularExecucao(id) {
    // this.addHistorico(id, usuarioExecutor, 'Iniciou a execução da Ordem de Serviço')

    // const itens = this.itens.filter(el => el.idOrdemServico == id)
    // for (const item of itens) {
    //   const percExecucao = round(aleatorioMinMax(0.9, 1.1))
    //   item.movimentacao = {
    //     data: new Date(),
    //     quantidade: item.quantidade * percExecucao,
    //     fotosAntes: [],
    //     fotosDepois: [],
    //     observacao: 'Item executado por ' + usuarioExecutor.nome
    //   }
    //   this.addHistorico(id, usuarioExecutor, 'Lançou movimentação do item', TipoHistoricoOrdemServicoEnum.MOVIMENTACAO, item.id)
    // }

    // this.addHistorico(id, usuarioExecutor, 'Finalizou a execução da Ordem de Serviço')

    // const ordemServico = this.ordensServico.find(el => el.id === id)
    // ordemServico.idStatus = StatusOrdemServicoEnum.AGUARDANDO_CONFERENCIA_EXECUCAO
  }

  async liberarFiscalizacao(idOrdemServico) {
    try {
      return await apiService.post(`ordem_servico/${idOrdemServico}/liberar_fiscalizacao_execucao`)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async finalizarSemaforica(idOrdemServico) {
    try {
      return await apiService.post(`ordem_servico/${idOrdemServico}/finalizar_semaforica`)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async atribuirCorrecao(idOrdemServico, idEquipe, itensSelecionados) {
    try {
      return await apiService.post(`ordem_servico/${idOrdemServico}/atribuir_correcao`, {
        idEquipe,
        itensSelecionados
      })
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async liberarFiscalizacaoCorrecao(idOrdemServico) {
    try {
      return await apiService.post(`ordem_servico/${idOrdemServico}/liberar_fiscalizacao_correcao`)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async iniciarFiscalizacao(idOrdemServico) {
    try {
      return await apiService.post(`ordem_servico/${idOrdemServico}/fiscalizacao/iniciar`)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async pausarFiscalizacao(idOrdemServico) {
    try {
      return await apiService.post(`ordem_servico/${idOrdemServico}/fiscalizacao/pausar`)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async finalizarFiscalizacao(idOrdemServico) {
    try {
      return await apiService.post(`ordem_servico/${idOrdemServico}/fiscalizacao/finalizar`)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async lancarDivergencia(idOrdemServico, idContratoItem, observacao, fotos) {
    try {
      return await apiService.post(`ordem_servico/${idOrdemServico}/item/${idContratoItem}/divergencia`, {
        observacao,
        fotos
      })
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async aprovarCorrecao(idOrdemServico, idCorrecao) {
    try {
      return await apiService.post(`ordem_servico/${idOrdemServico}/correcao/${idCorrecao}/aprovar`)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async reprovarCorrecao(idOrdemServico, idCorrecao, motivoReprovacao) {
    try {
      return await apiService.post(`ordem_servico/${idOrdemServico}/correcao/${idCorrecao}/reprovar`, {
        motivoReprovacao
      })
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }


  async selecionarEmpresaExecutora(idOrdemServico, idEmpresa) {
    try {
      return await apiService.post(`ordem_servico/${idOrdemServico}/selecionar_empresa_executora`, {
        idEmpresa
      })
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async excluirFotoItem(idOrdemServico, idContratoItem, idFoto) {
    try {
      return await apiService.delete(`ordem_servico/${idOrdemServico}/item/${idContratoItem}/foto/${idFoto}`)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }    
  }

  async incluirItemFoto(idOrdemServico, idContratoItem, idArquivoAntes, idArquivoDepois) {
    try {
      return await apiService.post(`ordem_servico/${idOrdemServico}/item/${idContratoItem}/foto`, {
        idArquivoAntes,
        idArquivoDepois
      })
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }    
  }

  async alterarItemFotoAntes(idOrdemServico, idContratoItem, idFoto, idArquivo) {
    try {
      return await apiService.put(`ordem_servico/${idOrdemServico}/item/${idContratoItem}/foto/${idFoto}/antes`, {
        idArquivo
      })
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }    
  }

  async alterarItemFotoDepois(idOrdemServico, idContratoItem, idFoto, idArquivo) {
    try {
      return await apiService.put(`ordem_servico/${idOrdemServico}/item/${idContratoItem}/foto/${idFoto}/depois`, {
        idArquivo
      })
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }    
  }

  async incluirFotoRefletancia(idOrdemServico, idContratoItem, idArquivo) {
    try {
      return await apiService.post(`ordem_servico/${idOrdemServico}/item/${idContratoItem}/foto_refletancia`, {
        idArquivo
      })
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async excluirFotoRefletancia(idOrdemServico, idContratoItem, idFoto) {
    try {
      return await apiService.delete(`ordem_servico/${idOrdemServico}/item/${idContratoItem}/foto_refletancia/${idFoto}`)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async excluirFotoMovimentacao(idOrdemServico, idContratoItem, idMovimentacao, idFoto) {
    try {
      return await apiService.delete(`ordem_servico/${idOrdemServico}/item/${idContratoItem}/movimentacao/${idMovimentacao}/foto/${idFoto}`)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async incluirFotoMovimentacao(idOrdemServico, idContratoItem, idMovimentacao, idArquivoAntes, idArquivoDepois) {
    try {
      return await apiService.post(`ordem_servico/${idOrdemServico}/item/${idContratoItem}/movimentacao/${idMovimentacao}/foto`, {
        idArquivoAntes,
        idArquivoDepois
      })
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async alterarFotoMovimentacaoAntes(idOrdemServico, idContratoItem, idMovimentacao, idFoto, idArquivo) {
    try {
      return await apiService.put(`ordem_servico/${idOrdemServico}/item/${idContratoItem}/movimentacao/${idMovimentacao}/foto/${idFoto}/antes`, {
        idArquivo
      })
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async alterarFotoMovimentacaoDepois(idOrdemServico, idContratoItem, idMovimentacao, idFoto, idArquivo) {
    try {
      return await apiService.put(`ordem_servico/${idOrdemServico}/item/${idContratoItem}/movimentacao/${idMovimentacao}/foto/${idFoto}/depois`, {
        idArquivo
      })
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async alterarGarantiaMovimentacao(idOrdemServico, idContratoItem, idMovimentacao, prazoGarantiaMeses) {
    try {
      return await apiService.put(`ordem_servico/${idOrdemServico}/item/${idContratoItem}/movimentacao/${idMovimentacao}/garantia`, {
        prazoGarantiaMeses
      })
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async alterarMovimentacao(idOrdemServico, idContratoItem, quantidade, observacao) {
    try {
      return await apiService.put(`ordem_servico/${idOrdemServico}/alterar_movimentacao/${idContratoItem}`, {
        quantidade,
        observacao
      })
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }    
  }


}

const ordemServicoService = new OrdemServicoService()
export default ordemServicoService